import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

const SITE_URL = "https://www.motardsbusinessclub.com";

/**
 * SEO par page — titre, description, canonical, Open Graph, Twitter, JSON-LD.
 * Les valeurs absolues utilisent le domaine de production confirmé par le client.
 */
export default function Seo({ title, description, path = "/", jsonLd = null, breadcrumb = null, noindex = false }) {
  useEffect(() => {
    const url = `${SITE_URL}${path === "/" ? "/" : path}`;
    const fullTitle = title.includes("MBC84") || title.includes("Motards Business Club 84") ? title : `${title} | MBC84`;
    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1");
    upsertLink("canonical", url);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "Motards Business Club 84");
    upsertMeta("property", "og:locale", "fr_FR");
    upsertMeta("property", "og:image", `${SITE_URL}/og-image.jpg`);
    upsertMeta("property", "og:image:alt", "Motards Business Club 84 — la passion de la moto, la force du réseau");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", `${SITE_URL}/og-image.jpg`);

    const blocks = [];
    if (breadcrumb) {
      blocks.push({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumb.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.label,
          item: `${SITE_URL}${b.path}`,
        })),
      });
    }
    if (jsonLd) blocks.push(jsonLd);
    const scripts = blocks.map((b) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.seoDynamic = "true";
      s.text = JSON.stringify(b);
      document.head.appendChild(s);
      return s;
    });
    return () => scripts.forEach((s) => s.remove());
  }, [title, description, path, jsonLd, breadcrumb]);

  return null;
}

export { SITE_URL };
